const initState = {
    error: null,
    loading: false
};

export function errorReducer(state = initState, action) {
    const { error } = action;
    const newState= {
        ...state,
        loading:action.loading,
        error: error
    }
    return newState

    // if (error) {
    //     console.log("THIS IS THE ERROR DUH... "+error)
    //     return {
    //         error: error
    //     }
    // }

    // return state;
}